<template>
    <div class="container-fluid">
        <b-card no-body class="my-2">
            <b-card-header class="">
                <b-card-title class="card-title-page-garden-help-default my-1">Customers
                </b-card-title>
            </b-card-header>
        </b-card>

        <div class="customers-garden-help">

            <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100%">
                <b-card no-body>
                    <b-card-header>
                        <b-row>
                            <b-col xl="6" lg="8" md="9">
                                <b-input-group class="input-group-search input-group-search-garden-help">
                                    <template #prepend>
                                        <font-awesome-icon icon="fa-solid fa-magnifying-glass" size="lg" />
                                    </template> <b-form-input v-model="search" class="form-control-garden-help"
                                        placeholder="Search "></b-form-input>
                                </b-input-group>
                            </b-col>
                        </b-row>
                    </b-card-header>
                    <b-card-body class="px-0">
                        <b-table-simple class="gardenHelpTable cursor-inherit" responsive stacked="md">
                            <b-thead>
                                <b-tr>
                                    <b-th>Customer</b-th>
                                    <b-th>Email</b-th>
                                    <b-th class="text-center">Last Job Location</b-th>
                                    <b-th>Last Order</b-th>
                                    <b-th class="text-center">No. Of Jobs</b-th>
                                    <b-th>Phone</b-th>
                                    <b-th></b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody v-if="customers.length > 0">
                                <b-tr v-for="(customer, index) in customers" :key="index">
                                    <b-td stacked-heading="Customer">
                                        <!-- <b-avatar :text="customer.first_name[0]+(customer.second_name?customer.second_name[0]:'')"
                                        class="avatar-garden-help avatar-garden-help-light"></b-avatar> -->
                                        <span>{{ customer.name }}</span></b-td>
                                    <b-td stacked-heading="Email">{{ customer.email }}</b-td>
                                    <b-td stacked-heading="Location" class="text-center">
                                        <img src="@/assets/images/garden-help/location-icon.png"
                                            :id="'location_' + customer.id" v-if="customer.last_job_location != null" />
                                        <b-popover custom-class="popover-garden-help" :target="'location_' + customer.id"
                                            triggers="hover" placement="left">
                                            {{ customer.last_job_location }}
                                        </b-popover>
                                    </b-td>
                                    <b-td stacked-heading="Last Order">
                                        <p class="">{{ customer.last_job_date }}</p>

                                    </b-td>

                                    <b-td stacked-heading="No Of Jobs" class="text-center">{{ customer.jobs_count
                                    }}</b-td>
                                    <b-td stacked-heading="Phone">{{ customer.phone }}</b-td>
                                    <b-td stacked-heading="" class="text-center">
                                        <b-button class="" variant="action-garden-help"
                                            @click="clickDeleteCustomer(customer.id)">
                                            <img src="@/assets/images/garden-help/delete-icon.png" />
                                        </b-button>
                                        <!-- <b-dropdown size="lg"  variant="link" toggle-class="text-decoration-none" no-caret>
                                            <template #button-content>
                                                &#x1f50d;<span class="sr-only">Search</span>
                                            </template>
                                            <b-dropdown-item-button>Action</b-dropdown-item-button>
                                            <b-dropdown-item-button>Another action</b-dropdown-item-button>
                                            <b-dropdown-item-button>Something else here...</b-dropdown-item-button>
                                        </b-dropdown> -->
                                    </b-td>

                                </b-tr>
                            </b-tbody>
                            <b-tbody v-else>
                                <b-tr>
                                    <b-td colspan="7" class="text-center cursor-initial">
                                        No results found
                                    </b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-card-body>
                </b-card>
                <!-- pagination -->
                <b-card class="card-transparent-background m-0" no-body>
                    <b-card-body class="px-2 py-0">
                        <b-row cols="1" cols-md="2">
                            <b-col>
                                <p class="data-list-info-garden-help">
                                    Showing {{ from_page }} to {{ to_page }} of
                                    {{ total_items }} entries
                                </p>
                            </b-col>
                            <b-col>
                                <b-pagination class="pagination-garden-help" v-model="currentPage" :total-rows="total_items"
                                    :per-page="perPage" limit="7" @change="changePage" size="md"></b-pagination></b-col>
                        </b-row>
                    </b-card-body>
                </b-card>
            </b-overlay>

        </div>

        <!-- delete modal -->
        <DeleteCustomer :customer_id="selected_customer_id" />
    </div>
</template>


<script>
import axios from "axios";
import $ from "jquery";
import DeleteCustomer from '../modal_actions/DeleteCustomer.vue'

export default {
    name: "GardenHelpCustomerCurrentList",
    components: { DeleteCustomer },
    data() {
        return {
            show_overlay: false,
            client_name: "GARDENHELP",
            user_type: localStorage.getItem('user_type'),
            user_id: null, // logined user

            customers: [],
            selected_customer_id: null,

            search: "",
            // pagination
            perPage: 10,
            currentPage: 1,
            total_items: 0,
            from_page: 0,
            to_page: 0,
        }
    },
    mounted() {
        let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = user.id

        // this.getFilterData()

        this.getCustomersList()
    },
    
    watch:{
        search(newval){
            console.log("search", this.search)
            this.getCustomersList()
        }
    },
    methods: {
        changePage(value) {
            console.log("change page", value);
            this.currentPage = value
            this.getCustomersList()
        },
        getCustomersList() {
            console.log("in get customer list", this.user_type, this.user_id)
            this.show_overlay = true
            let params_request = "?paginate=1&per_page=" + this.perPage + "&page=" + this.currentPage;
            console.log(params_request)


            if (this.search != null && this.search != "") {
                params_request += "&keyword=" + this.search
            }
            console.log(params_request)

            axios
                .get("/admin/users" + params_request, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)
                    this.customers = response.data.data;

                    // for (let i = 0; i < this.customers.length; i++) {
                    //     this.customers[i].location = 'Dublin'
                    //     this.customers[i].last_order = '7 May 23'
                    //     this.customers[i].number_of_jobs = 5

                    // }

                    // this.total_items = response.data.length
                    // if (response.data.length == 0) {
                    //     this.from_page = 0
                    //     this.to_page = 0
                    // } else {
                    //     this.from_page = ((this.currentPage - 1) * this.perPage) + 1
                    //     this.to_page = this.currentPage * this.perPage > response.data.length ? response.data.length : this.currentPage * this.perPage
                    // }
                    this.total_items = response.data.meta.total
                    if (response.data.meta.total == 0) {
                        this.from_page = 0
                        this.to_page = 0
                    } else {
                        this.from_page = ((this.currentPage - 1) * this.perPage) + 1
                        this.to_page = this.currentPage * this.perPage > response.data.meta.total ? response.data.meta.total : this.currentPage * this.perPage
                    }
                    this.show_overlay = false

                });
        },
        clickDeleteCustomer(id) {
            console.log("delete customer ", id)
            this.selected_customer_id = id
            this.$root.$emit("bv::show::modal", "deleteCustomerModal");
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/customer/List/Current.vue